/**
 * @generated SignedSource<<7ee179aa057eaf664e0704b5803cf773>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type BoardActions$data = {
  readonly projectId: string | null | undefined;
  readonly projectKey: string;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "BoardActions";
};
export type BoardActions$key = {
  readonly " $data"?: BoardActions$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardActions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardActions",
  "selections": [
    {
      "alias": "projectKey",
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5bec975119349e415418460f22de0625";

export default node;
